var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.cof.js
// module id = 100
// module chunks = 174 178 179 182 193 194 195